export const countryList = [
  { code: "AF", name: "Afghanistan", number: "004" },
  { code: "AL", name: "Albania", number: "008" },
  { code: "DZ", name: "Algeria", number: "012" },
  { code: "AS", name: "American Samoa", number: "016" },
  { code: "AD", name: "Andorra", number: "020" },
  { code: "AO", name: "Angola", number: "024" },
  { code: "AI", name: "Anguilla", number: "660" },
  { code: "AQ", name: "Antarctica", number: "010" },
  { code: "AG", name: "Antigua and Barbuda", number: "028" },
  { code: "AR", name: "Argentina", number: "032" },
  { code: "AM", name: "Armenia", number: "051" },
  { code: "AW", name: "Aruba", number: "533" },
  { code: "AU", name: "Australia", number: "036" },
  { code: "AT", name: "Austria", number: "040" },
  { code: "AZ", name: "Azerbaijan", number: "031" },
  { code: "BS", name: "Bahamas (the)", number: "044" },
  { code: "BH", name: "Bahrain", number: "048" },
  { code: "BD", name: "Bangladesh", number: "050" },
  { code: "BB", name: "Barbados", number: "052" },
  { code: "BY", name: "Belarus", number: "112" },
  { code: "BE", name: "Belgium", number: "056" },
  { code: "BZ", name: "Belize", number: "084" },
  { code: "BJ", name: "Benin", number: "204" },
  { code: "BM", name: "Bermuda", number: "060" },
  { code: "BT", name: "Bhutan", number: "064" },
  { code: "BO", name: "Bolivia (Plurinational State of)", number: "068" },
  { code: "BQ", name: "Bonaire, Sint Eustatius and Saba", number: "535" },
  { code: "BA", name: "Bosnia and Herzegovina", number: "070" },
  { code: "BW", name: "Botswana", number: "072" },
  { code: "BV", name: "Bouvet Island", number: "074" },
  { code: "BR", name: "Brazil", number: "076" },
  { code: "IO", name: "British Indian Ocean Territory (the)", number: "086" },
  { code: "BN", name: "Brunei Darussalam", number: "096" },
  { code: "BG", name: "Bulgaria", number: "100" },
  { code: "BF", name: "Burkina Faso", number: "854" },
  { code: "BI", name: "Burundi", number: "108" },
  { code: "CV", name: "Cabo Verde", number: "132" },
  { code: "KH", name: "Cambodia", number: "116" },
  { code: "CM", name: "Cameroon", number: "120" },
  { code: "CA", name: "Canada", number: "124" },
  { code: "KY", name: "Cayman Islands (the)", number: "136" },
  { code: "CF", name: "Central African Republic (the)", number: "140" },
  { code: "TD", name: "Chad", number: "148" },
  { code: "CL", name: "Chile", number: "152" },
  { code: "CN", name: "China", number: "156" },
  { code: "CX", name: "Christmas Island", number: "162" },
  { code: "CC", name: "Cocos (Keeling) Islands (the)", number: "166" },
  { code: "CO", name: "Colombia", number: "170" },
  { code: "KM", name: "Comoros (the)", number: "174" },
  { code: "CD", name: "Congo (the Democratic Republic of the)", number: "180" },
  { code: "CG", name: "Congo (the)", number: "178" },
  { code: "CK", name: "Cook Islands (the)", number: "184" },
  { code: "CR", name: "Costa Rica", number: "188" },
  { code: "HR", name: "Croatia", number: "191" },
  { code: "CU", name: "Cuba", number: "192" },
  { code: "CW", name: "Curaçao", number: "531" },
  { code: "CY", name: "Cyprus", number: "196" },
  { code: "CZ", name: "Czechia", number: "203" },
  { code: "CI", name: "Côte d'Ivoire", number: "384" },
  { code: "DK", name: "Denmark", number: "208" },
  { code: "DJ", name: "Djibouti", number: "262" },
  { code: "DM", name: "Dominica", number: "212" },
  { code: "DO", name: "Dominican Republic (the)", number: "214" },
  { code: "EC", name: "Ecuador", number: "218" },
  { code: "EG", name: "Egypt", number: "818" },
  { code: "SV", name: "El Salvador", number: "222" },
  { code: "GQ", name: "Equatorial Guinea", number: "226" },
  { code: "ER", name: "Eritrea", number: "232" },
  { code: "EE", name: "Estonia", number: "233" },
  { code: "SZ", name: "Eswatini", number: "748" },
  { code: "ET", name: "Ethiopia", number: "231" },
  { code: "FK", name: "Falkland Islands (the) [Malvinas]", number: "238" },
  { code: "FO", name: "Faroe Islands (the)", number: "234" },
  { code: "FJ", name: "Fiji", number: "242" },
  { code: "FI", name: "Finland", number: "246" },
  { code: "FR", name: "France", number: "250" },
  { code: "GF", name: "French Guiana", number: "254" },
  { code: "PF", name: "French Polynesia", number: "258" },
  { code: "TF", name: "French Southern Territories (the)", number: "260" },
  { code: "GA", name: "Gabon", number: "266" },
  { code: "GM", name: "Gambia (the)", number: "270" },
  { code: "GE", name: "Georgia", number: "268" },
  { code: "DE", name: "Germany", number: "276" },
  { code: "GH", name: "Ghana", number: "288" },
  { code: "GI", name: "Gibraltar", number: "292" },
  { code: "GR", name: "Greece", number: "300" },
  { code: "GL", name: "Greenland", number: "304" },
  { code: "GD", name: "Grenada", number: "308" },
  { code: "GP", name: "Guadeloupe", number: "312" },
  { code: "GU", name: "Guam", number: "316" },
  { code: "GT", name: "Guatemala", number: "320" },
  { code: "GG", name: "Guernsey", number: "831" },
  { code: "GN", name: "Guinea", number: "324" },
  { code: "GW", name: "Guinea-Bissau", number: "624" },
  { code: "GY", name: "Guyana", number: "328" },
  { code: "HT", name: "Haiti", number: "332" },
  { code: "HM", name: "Heard Island and McDonald Islands", number: "334" },
  { code: "VA", name: "Holy See (the)", number: "336" },
  { code: "HN", name: "Honduras", number: "340" },
  { code: "HK", name: "Hong Kong", number: "344" },
  { code: "HU", name: "Hungary", number: "348" },
  { code: "IS", name: "Iceland", number: "352" },
  { code: "IN", name: "India", number: "356" },
  { code: "ID", name: "Indonesia", number: "360" },
  { code: "IR", name: "Iran (Islamic Republic of)", number: "364" },
  { code: "IQ", name: "Iraq", number: "368" },
  { code: "IE", name: "Ireland", number: "372" },
  { code: "IM", name: "Isle of Man", number: "833" },
  { code: "IL", name: "Israel", number: "376" },
  { code: "IT", name: "Italy", number: "380" },
  { code: "JM", name: "Jamaica", number: "388" },
  { code: "JP", name: "Japan", number: "392" },
  { code: "JE", name: "Jersey", number: "832" },
  { code: "JO", name: "Jordan", number: "400" },
  { code: "KZ", name: "Kazakhstan", number: "398" },
  { code: "KE", name: "Kenya", number: "404" },
  { code: "KI", name: "Kiribati", number: "296" },
  {
    code: "KP",
    name: "Korea (the Democratic People's Republic of)",
    number: "408",
  },
  { code: "KR", name: "Korea (the Republic of)", number: "410" },
  { code: "KW", name: "Kuwait", number: "414" },
  { code: "KG", name: "Kyrgyzstan", number: "417" },
  { code: "LA", name: "Lao People's Democratic Republic (the)", number: "418" },
  { code: "LV", name: "Latvia", number: "428" },
  { code: "LB", name: "Lebanon", number: "422" },
  { code: "LS", name: "Lesotho", number: "426" },
  { code: "LR", name: "Liberia", number: "430" },
  { code: "LY", name: "Libya", number: "434" },
  { code: "LI", name: "Liechtenstein", number: "438" },
  { code: "LT", name: "Lithuania", number: "440" },
  { code: "LU", name: "Luxembourg", number: "442" },
  { code: "MO", name: "Macao", number: "446" },
  { code: "MG", name: "Madagascar", number: "450" },
  { code: "MW", name: "Malawi", number: "454" },
  { code: "MY", name: "Malaysia", number: "458" },
  { code: "MV", name: "Maldives", number: "462" },
  { code: "ML", name: "Mali", number: "466" },
  { code: "MT", name: "Malta", number: "470" },
  { code: "MH", name: "Marshall Islands (the)", number: "584" },
  { code: "MQ", name: "Martinique", number: "474" },
  { code: "MR", name: "Mauritania", number: "478" },
  { code: "MU", name: "Mauritius", number: "480" },
  { code: "YT", name: "Mayotte", number: "175" },
  { code: "MX", name: "Mexico", number: "484" },
  { code: "FM", name: "Micronesia (Federated States of)", number: "583" },
  { code: "MD", name: "Moldova (the Republic of)", number: "498" },
  { code: "MC", name: "Monaco", number: "492" },
  { code: "MN", name: "Mongolia", number: "496" },
  { code: "ME", name: "Montenegro", number: "499" },
  { code: "MS", name: "Montserrat", number: "500" },
  { code: "MA", name: "Morocco", number: "504" },
  { code: "MZ", name: "Mozambique", number: "508" },
  { code: "MM", name: "Myanmar", number: "104" },
  { code: "NA", name: "Namibia", number: "516" },
  { code: "NR", name: "Nauru", number: "520" },
  { code: "NP", name: "Nepal", number: "524" },
  { code: "NL", name: "Netherlands (the)", number: "528" },
  { code: "NC", name: "New Caledonia", number: "540" },
  { code: "NZ", name: "New Zealand", number: "554" },
  { code: "NI", name: "Nicaragua", number: "558" },
  { code: "NE", name: "Niger (the)", number: "562" },
  { code: "NG", name: "Nigeria", number: "566" },
  { code: "NU", name: "Niue", number: "570" },
  { code: "NF", name: "Norfolk Island", number: "574" },
  { code: "MP", name: "Northern Mariana Islands (the)", number: "580" },
  { code: "NO", name: "Norway", number: "578" },
  { code: "OM", name: "Oman", number: "512" },
  { code: "PK", name: "Pakistan", number: "586" },
  { code: "PW", name: "Palau", number: "585" },
  { code: "PS", name: "Palestine, State of", number: "275" },
  { code: "PA", name: "Panama", number: "591" },
  { code: "PG", name: "Papua New Guinea", number: "598" },
  { code: "PY", name: "Paraguay", number: "600" },
  { code: "PE", name: "Peru", number: "604" },
  { code: "PH", name: "Philippines (the)", number: "608" },
  { code: "PN", name: "Pitcairn", number: "612" },
  { code: "PL", name: "Poland", number: "616" },
  { code: "PT", name: "Portugal", number: "620" },
  { code: "PR", name: "Puerto Rico", number: "630" },
  { code: "QA", name: "Qatar", number: "634" },
  { code: "MK", name: "Republic of North Macedonia", number: "807" },
  { code: "RO", name: "Romania", number: "642" },
  { code: "RU", name: "Russian Federation (the)", number: "643" },
  { code: "RW", name: "Rwanda", number: "646" },
  { code: "RE", name: "Réunion", number: "638" },
  { code: "BL", name: "Saint Barthélemy", number: "652" },
  {
    code: "SH",
    name: "Saint Helena, Ascension and Tristan da Cunha",
    number: "654",
  },
  { code: "KN", name: "Saint Kitts and Nevis", number: "659" },
  { code: "LC", name: "Saint Lucia", number: "662" },
  { code: "MF", name: "Saint Martin (French part)", number: "663" },
  { code: "PM", name: "Saint Pierre and Miquelon", number: "666" },
  { code: "VC", name: "Saint Vincent and the Grenadines", number: "670" },
  { code: "WS", name: "Samoa", number: "882" },
  { code: "SM", name: "San Marino", number: "674" },
  { code: "ST", name: "Sao Tome and Principe", number: "678" },
  { code: "SA", name: "Saudi Arabia", number: "682" },
  { code: "SN", name: "Senegal", number: "686" },
  { code: "RS", name: "Serbia", number: "688" },
  { code: "SC", name: "Seychelles", number: "690" },
  { code: "SL", name: "Sierra Leone", number: "694" },
  { code: "SG", name: "Singapore", number: "702" },
  { code: "SX", name: "Sint Maarten (Dutch part)", number: "534" },
  { code: "SK", name: "Slovakia", number: "703" },
  { code: "SI", name: "Slovenia", number: "705" },
  { code: "SB", name: "Solomon Islands", number: "090" },
  { code: "SO", name: "Somalia", number: "706" },
  { code: "ZA", name: "South Africa", number: "710" },
  {
    code: "GS",
    name: "South Georgia and the South Sandwich Islands",
    number: "239",
  },
  { code: "SS", name: "South Sudan", number: "728" },
  { code: "ES", name: "Spain", number: "724" },
  { code: "LK", name: "Sri Lanka", number: "144" },
  { code: "SD", name: "Sudan (the)", number: "729" },
  { code: "SR", name: "Suriname", number: "740" },
  { code: "SJ", name: "Svalbard and Jan Mayen", number: "744" },
  { code: "SE", name: "Sweden", number: "752" },
  { code: "CH", name: "Switzerland", number: "756" },
  { code: "SY", name: "Syrian Arab Republic", number: "760" },
  { code: "TW", name: "Taiwan", number: "158" },
  { code: "TJ", name: "Tajikistan", number: "762" },
  { code: "TZ", name: "Tanzania, United Republic of", number: "834" },
  { code: "TH", name: "Thailand", number: "764" },
  { code: "TL", name: "Timor-Leste", number: "626" },
  { code: "TG", name: "Togo", number: "768" },
  { code: "TK", name: "Tokelau", number: "772" },
  { code: "TO", name: "Tonga", number: "776" },
  { code: "TT", name: "Trinidad and Tobago", number: "780" },
  { code: "TN", name: "Tunisia", number: "788" },
  { code: "TR", name: "Turkey", number: "792" },
  { code: "TM", name: "Turkmenistan", number: "795" },
  { code: "TC", name: "Turks and Caicos Islands (the)", number: "796" },
  { code: "TV", name: "Tuvalu", number: "798" },
  { code: "UG", name: "Uganda", number: "800" },
  { code: "UA", name: "Ukraine", number: "804" },
  { code: "AE", name: "United Arab Emirates (the)", number: "784" },
  {
    code: "GB",
    name: "United Kingdom of Great Britain and Northern Ireland (the)",
    number: "826",
  },
  {
    code: "UM",
    name: "United States Minor Outlying Islands (the)",
    number: "581",
  },
  { code: "US", name: "United States of America (the)", number: "840" },
  { code: "UY", name: "Uruguay", number: "858" },
  { code: "UZ", name: "Uzbekistan", number: "860" },
  { code: "VU", name: "Vanuatu", number: "548" },
  { code: "VE", name: "Venezuela (Bolivarian Republic of)", number: "862" },
  { code: "VN", name: "Viet Nam", number: "704" },
  { code: "VG", name: "Virgin Islands (British)", number: "092" },
  { code: "VI", name: "Virgin Islands (U.S.)", number: "850" },
  { code: "WF", name: "Wallis and Futuna", number: "876" },
  { code: "EH", name: "Western Sahara", number: "732" },
  { code: "YE", name: "Yemen", number: "887" },
  { code: "ZM", name: "Zambia", number: "894" },
  { code: "ZW", name: "Zimbabwe", number: "716" },
  { code: "AX", name: "Åland Islands", number: "248" },
];
